import {
    Star,
    MessageSquare,
} from "lucide-react";

import "./ReviewsTab.css";

function ReviewsTab({ food }) {

    const averageRating = food.rating || 0;
    const totalReviews = food.ratingCount || 0;

    return (

        <div className="reviews-tab">

            <div className="reviews-summary">

                <div className="rating-card">

                    <Star
                        size={48}
                        fill="#F59E0B"
                        color="#F59E0B"
                    />

                    <h1>{averageRating.toFixed(1)}</h1>

                    <p>Average Rating</p>

                </div>

                <div className="review-card">

                    <MessageSquare size={42} />

                    <h1>{totalReviews}</h1>

                    <p>Total Reviews</p>

                </div>

            </div>

            <div className="review-placeholder">

                <h2>Customer Reviews</h2>

                <p>

                    Individual customer reviews will appear here once the
                    review module is integrated.

                </p>

            </div>

        </div>

    );

}

export default ReviewsTab;